import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { testimonials } from "../../data/landing";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
export function Testimonials() {
  return <section className="bg-white px-5 py-16" data-id="element-264" data-mp="3mfhd3vplxfdi">
      <SectionHeading eyebrow="What clinicians are saying" title="Professionals already working with the Blueprint" data-id="element-265" data-mp="3r80vr735j0p6" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-2" data-id="element-266" data-mp="6872lw6snm">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-cream p-6 ring-1 ring-navy/10" data-id="element-267" data-mp="41i2hlfpo225">
            <div className="flex items-center gap-4" data-id="element-268" data-mp="92fe1f67txuo">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-269" data-mp="e1im78hhsk6v" />
              <div data-id="element-270" data-mp="2aukc78eb5rdu">
                <p className="text-lg font-bold text-ink" data-id="element-271" data-mp="2avde9w2bnspn">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-272" data-mp="2ft53ujfhv2qo">{t.role}</p>
                <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-273" data-mp="1sk9dcmcuqoe7">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-274" data-mp="1ns9i377q8jny" data-mpi={i} />)}
                </div>
              </div>
            </div>
            <blockquote className="mt-5 flex gap-3 text-[17px] leading-relaxed text-ink" data-id="element-275" data-mp="1eu5ywhk7ryzb">
              <QuoteIcon className="h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-276" data-mp="2bic69c8it5ha" />
              <p data-id="element-277" data-mp="26jsg0zmw97j4">{t.quote}</p>
            </blockquote>
          </figure>)}
      </div>
      <TransformCta label="I want the same clarity in my practice" data-id="element-278" data-mp="22i7a5y8s1tif" />
    </section>;
}